import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { HelmetMeta } from './HelmetMeta';
import { ThemeProvider } from '../components/theme/ThemeProvider';
import { CssBaseline } from '@material-ui/core';
import { logCredits } from '../utils/logCredits';
import { Home } from '../pages/Home';


const PageNotFound = lazy(() => import('../pages/PageNotFound'));

const App = () => {
  logCredits();

  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <HelmetMeta />
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
};

export default App;
